import React from "react";

import PortaleChildApp from "../../portale-child-app";

const TshChildApp = () => {
    return <PortaleChildApp disableDataPropagation={true} appId="TSH" serviceId="TSH" />;
};

export default TshChildApp;
